<template>
  <div :class="$style.toolbar">
    <div v-if="user" :class="$style.user">
      <button v-if="!userName" @click="onLogin" style="position: relative; top: 0.2rem">
        您好，请先【绑定角色】
      </button>
      <template v-else>
        <div>{{ serverName }}{{ userName }}</div>
        <button @click="onLogin">切换角色</button>
      </template>
    </div>
    <!-- 下载按钮 -->
    <btn-download style="position: absolute; top: 0.31rem; right: 1.08rem" />
    <!-- 分享按钮 -->
    <btn-share request-share style="position: absolute; top: 0.25rem; right: 0.3rem" />
  </div>
</template>

<script>
import { BtnDownload, BtnShare } from '@/components/widgets'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheToolbar',
  components: {
    BtnDownload,
    BtnShare
  },
  computed: {
    ...mapGetters(['user']),
    userName() {
      return this.user && this.user.role_name
    },
    serverName() {
      return this.user && this.user.server_name ? `【${this.user.server_name}】 ` : ''
    }
  },
  methods: {
    ...mapActions(['clearToken']),
    onLogin() {
      this.$emit('login')
    },
    onLogout() {
      this.clearToken()
      location.reload()
    }
  }
}
</script>

<style lang="less" module>
.toolbar {
  .background-fill('./images/toolbar-bg.jpg');

  height: 1.11rem;
}

.user {
  position: absolute;
  top: 0.12rem;
  left: 2.24rem;
  width: 2.8rem;
  text-align: center;
  font-size: 0.24rem;
  line-height: 1.5;
  color: #79fff5;

  button {
    display: inline-block;
    padding-bottom: 0.03rem;
    border-bottom: 1px solid #79fff5;
  }
}
</style>
